<template>
  <div class="school-list-content">
    <!-- 筛选区域 -->
    <el-card class="filter-container">
      <template #header>
        <div class="clearfix">
          <span>筛选条件</span>
        </div>
      </template>
      <el-form :inline="true" :model="filterForm" class="demo-form-inline">
        <el-form-item label="院校类型">
          <el-select
            v-model="filterForm.schoolType"
            placeholder="请选择院校类型"
          >
            <el-option
              v-for="item in schoolTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="resetFilters">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 院校结果展示 -->
      <div class="school-results">
        <div class="result-count">
          共找到<span class="highlight">{{ filteredSchools.length }}</span>所院校
        </div>
        <div class="school-cards">
          <el-card
            v-for="school in filteredSchools"
            :key="school.id"
            class="inner-school-card"
          >
            <template #header>
              <div class="card-header">
                <img
                  :src="school.logo"
                  alt="正在加载中......"
                  class="school-logo"
                />
                <div class="school-info">
                  <h3>{{ school.name }}</h3>
                  <p>{{ school.type }} | {{ school.address }}</p>
                </div>
              </div>
            </template>
            <div class="school-details">
              <div class="detail-row">
                <span class="label">招生性别：</span>
                <span>{{ school.nature }}</span>
              </div>
              <div class="detail-row">
                <span class="label">招生类别：</span>
                <span>{{ school.discipline_level }}</span>
              </div>
            </div>
            <div class="card-bottom-actions">
              <el-button
                class="favorite-btn"
                @click.stop="toggleFavorite(school)"
                :icon="school.schoolcollectId ? StarFilled : Star"
                circle
              />
              <el-button
                size="small"
                type="primary"
                @click="viewDetail(school.id)"
                >查看详情</el-button
              >
            </div>
          </el-card>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { getSchools } from "@/api/schoolApi";
import { useFavoriteStore } from "@/store";
import { Star, StarFilled } from "@element-plus/icons-vue";
import { baseURL } from "@/api/axiosConfig";

const router = useRouter();
const favoriteStore = useFavoriteStore();

// 筛选表单
const filterForm = ref({
  schoolType: "",
});

// 院校类型选项
const schoolTypes = ref([
  { value: "中央军委直属院校", label: "中央军委直属院校" },
  { value: "陆军院校", label: "陆军院校" },
  { value: "海军院校", label: "海军院校" },
  { value: "空军院校", label: "空军院校" },
  { value: "武警院校", label: "武警院校" },
  { value: "火箭军院校", label: "火箭军院校" },
  { value: "联勤保障部队院校", label: "联勤保障部队院校" },
  { value: "网络空间部队院校", label: "网络空间部队院校" },
  { value: "信息支援部队院校", label: "信息支援部队院校" },
  { value: "军事航天部队院校", label: "军事航天部队院校" },
]);

// 所有原始数据
const allSchools = ref([]);

// 获取学校数据
const fetchSchools = async () => {
  try {
    const res = await getSchools();
    const data = res.data.data.map((item) => ({
      id: item.id,
      name: item.name,
      address: item.address,
      type: item.type,
      nature: item.nature,
      discipline_level: item.disciplineLevel,
      logo: baseURL + item.logo,
      schoolcollectId: item.schoolcollectId,
    }));
    allSchools.value = data;
  } catch (err) {
    console.error("数据加载失败:", err);
  }
};

// 前台筛选计算属性
const filteredSchools = computed(() => {
  let result = allSchools.value;
  if (filterForm.value.schoolType) {
    result = result.filter(
      (school) => school.type === filterForm.value.schoolType
    );
  }
  return result;
});

// 切换收藏状态
const toggleFavorite = async (school) => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  if (!auth || !auth._token) {
    ElMessage.warning("请先登录");
    return;
  }
  const token = auth._token;

  try {
    if (school.schoolcollectId) {
      await favoriteStore.removeFavorite(token, school.id);
      school.schoolcollectId = null;
      ElMessage.success("已取消收藏");
    } else {
      await favoriteStore.addFavorite(token, school.id);
      school.schoolcollectId = school.id;
      ElMessage.success("收藏成功");
    }
  } catch (error) {
    console.error("操作失败:", error);
    ElMessage.error("操作失败");
  }
};

// 查询方法
const search = () => {
  console.log("Search triggered with:", filterForm.value);
};

// 重置筛选条件
const resetFilters = () => {
  filterForm.value.schoolType = "";
};

// 查看详情方法
const viewDetail = (schoolId) => {
  router.push({
    name: "SchoolDetail",
    params: { id: schoolId },
  });
};

onMounted(async () => {
  const token = localStorage.getItem("token");
  if (token) {
    await favoriteStore.fetchFavorites(token);
  }
  await fetchSchools();
});
</script>

<style scoped>
.school-list-content {
  padding: 0;
}

.filter-container {
  margin-top: -5px;
  padding: 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.filter-container :deep(.el-card__header) {
  padding: 0 0 15px;
  margin-bottom: 15px;
  border-bottom: 2px solid #3b82f6;
  background: transparent;
}

.filter-container :deep(.el-card__header) span {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.demo-form-inline {
  display: flex;
  align-items: center;
  gap: 15px;
}

.demo-form-inline .el-form-item {
  margin-bottom: 0;
}

.demo-form-inline .el-select {
  width: 180px;
  border-radius: 8px;
}

.demo-form-inline :deep(.el-input__wrapper) {
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.demo-form-inline .el-form-item__content .el-button + .el-button {
  margin-left: 8px;
}

.result-count {
  font-size: 14px;
  padding: 10px 0;
  margin-top: 15px;
  color: #64748b;
  border-top: 1px dashed #cbd5e1;
}

.highlight {
  color: #3b82f6;
  font-weight: 700;
  padding: 2px 6px;
  background: #dbeafe;
  border-radius: 4px;
  margin: 0 4px;
}

.school-results {
  margin-top: 20px;
}

.school-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  padding: 0 5px;
}

.inner-school-card {
  border-radius: 12px;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 290px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.inner-school-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(59, 130, 246, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
  border-color: #3b82f6;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

.school-logo {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  margin-right: 16px;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 2px solid #f1f5f9;
}

.school-info h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
}

.school-info p {
  color: #64748b;
  margin: 6px 0 0;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.school-info p::before {
  content: '';
  width: 2px;
  height: 12px;
  background: #94a3b8;
}

.school-details {
  padding: 16px;
  flex-grow: 1;
}

.detail-row {
  display: flex;
  align-items: center;
  margin: 10px 0;
  font-size: 14px;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 8px;
}

.label {
  color: #64748b;
  min-width: 80px;
  font-weight: 500;
}

.detail-row span:last-child {
  color: #1e293b;
  font-weight: 500;
}

.card-actions {
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
  text-align: right;
}

.card-bottom-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding: 12px 16px;
  background: #fafbfc;
  border-top: 1px solid #f1f5f9;
}

.favorite-btn {
  position: relative;
  z-index: 1;
  margin-left: auto;
  --el-button-hover-bg-color: rgba(251, 191, 36, 0.1);
  --el-button-hover-text-color: #f59e0b;
}

.favorite-btn :deep(.el-icon) {
  font-size: 18px;
}

.card-bottom-actions :deep(.el-button--primary) {
  border-radius: 8px;
  padding: 6px 20px;
  font-weight: 500;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
}

.card-bottom-actions :deep(.el-button--primary:hover) {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}
</style>
